<script>
  export let speed = 50;
  export let duration = 600;
  export let value;
  export let update = 0;

  let _v = 0;

  let isSpinning = true;

  $: if (update !== undefined && value > 0)
    {
    spin()
    }else{
    _v = value;
    };

  const spin = () => {
    let count = Math.floor(duration / speed);

    const handler = () => {
      count--;
      if (count) {
        _v = Math.round(Math.random() * 99);
        setTimeout(handler, speed);
      } else {
        _v = value;
      }
    };

    setTimeout(handler, speed);
    isSpinning = true;
  };
</script>

{_v}
